/* =========================================================
   SMART KIDS KUWAIT — CART UPSELL OFFERS
   Adds upsell product to Shopify cart via Ajax
   + Shows one offer only per offer group
   + Prevents Shopify cart quantity validation from touching upsell qty
   ========================================================= */

(() => {
  if (window.SKK_CART_UPSELL_OFFERS_READY) return;
  window.SKK_CART_UPSELL_OFFERS_READY = true;

  const STORAGE_PREFIX = 'skk_cart_upsell_selected_';

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function getSectionsToRender() {
    const sections = ['cart-drawer', 'cart-icon-bubble'];

    const mainCartItems = document.getElementById('main-cart-items');
    const mainCartFooter = document.getElementById('main-cart-footer');

    if (mainCartItems && mainCartItems.dataset.id) {
      sections.push(mainCartItems.dataset.id);
    }

    if (mainCartFooter && mainCartFooter.dataset.id) {
      sections.push(mainCartFooter.dataset.id);
    }

    return [...new Set(sections)];
  }

  function initOfferGroups() {
    const offerLists = document.querySelectorAll('[data-skk-cart-upsell-list]');

    offerLists.forEach((list) => {
      const offers = Array.from(list.querySelectorAll('[data-skk-cart-upsell]'));
      const groups = {};

      offers.forEach((offer) => {
        const group = offer.dataset.skkOfferGroup || 'default';

        if (!groups[group]) {
          groups[group] = [];
        }

        groups[group].push(offer);
      });

      Object.entries(groups).forEach(([group, groupOffers]) => {
        if (groupOffers.length <= 1) {
          groupOffers.forEach((offer) => {
            offer.hidden = false;
          });
          return;
        }

        const storageKey = STORAGE_PREFIX + group;
        let selectedOfferId = localStorage.getItem(storageKey);

        const selectedStillExists = groupOffers.some((offer) => {
          return offer.dataset.skkOfferId === selectedOfferId;
        });

        if (!selectedOfferId || !selectedStillExists) {
          const randomIndex = Math.floor(Math.random() * groupOffers.length);
          selectedOfferId = groupOffers[randomIndex].dataset.skkOfferId;
          localStorage.setItem(storageKey, selectedOfferId);
        }

        groupOffers.forEach((offer) => {
          offer.hidden = offer.dataset.skkOfferId !== selectedOfferId;
        });
      });
    });
  }

  function updateCartIcon(parsedState) {
    if (!parsedState.sections || !parsedState.sections['cart-icon-bubble']) return;

    const html = parseHTML(parsedState.sections['cart-icon-bubble']);
    const newIcon = html.querySelector('.shopify-section');
    const currentIcon = document.getElementById('cart-icon-bubble');

    if (newIcon && currentIcon) {
      currentIcon.innerHTML = newIcon.innerHTML;
    }
  }

  function updateCartDrawer(parsedState) {
    const cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer && typeof cartDrawer.renderContents === 'function' && parsedState.sections['cart-drawer']) {
      cartDrawer.renderContents(parsedState);
      setTimeout(initOfferGroups, 100);
      return;
    }

    if (!parsedState.sections || !parsedState.sections['cart-drawer']) return;

    const html = parseHTML(parsedState.sections['cart-drawer']);
    const newDrawer = html.querySelector('#CartDrawer');
    const currentDrawer = document.querySelector('#CartDrawer');

    if (newDrawer && currentDrawer) {
      currentDrawer.innerHTML = newDrawer.innerHTML;
      setTimeout(initOfferGroups, 100);
    }
  }

  function updateMainCartPage(parsedState) {
    const mainCartItems = document.getElementById('main-cart-items');
    const mainCartFooter = document.getElementById('main-cart-footer');

    if (mainCartItems && mainCartItems.dataset.id && parsedState.sections[mainCartItems.dataset.id]) {
      const html = parseHTML(parsedState.sections[mainCartItems.dataset.id]);
      const newCartItems = html.querySelector('cart-items');
      const currentCartItems = document.querySelector('cart-items');

      if (newCartItems && currentCartItems) {
        currentCartItems.innerHTML = newCartItems.innerHTML;
      }
    }

    if (mainCartFooter && mainCartFooter.dataset.id && parsedState.sections[mainCartFooter.dataset.id]) {
      const html = parseHTML(parsedState.sections[mainCartFooter.dataset.id]);
      const newFooterContents = html.querySelector('#main-cart-footer .js-contents');
      const currentFooterContents = document.querySelector('#main-cart-footer .js-contents');

      if (newFooterContents && currentFooterContents) {
        currentFooterContents.innerHTML = newFooterContents.innerHTML;
      }
    }

    setTimeout(initOfferGroups, 100);
  }

  function hideError(button) {
    const wrapper = button.closest('[data-skk-cart-upsell]');
    const error = wrapper ? wrapper.querySelector('[data-skk-upsell-error]') : null;

    if (!error) return;

    error.textContent = '';
    error.hidden = true;
  }

  function showError(button, message) {
    const wrapper = button.closest('[data-skk-cart-upsell]');
    const error = wrapper ? wrapper.querySelector('[data-skk-upsell-error]') : null;

    if (!error) return;

    error.textContent = message || 'حدث خطأ أثناء إضافة المنتج. الرجاء المحاولة مرة أخرى.';
    error.hidden = false;
  }

  document.addEventListener(
    'change',
    (event) => {
      if (event.target.closest('[data-skk-upsell-qty]')) {
        event.stopPropagation();
      }
    },
    true
  );

  document.addEventListener(
    'input',
    (event) => {
      if (event.target.closest('[data-skk-upsell-qty]')) {
        event.stopPropagation();
      }
    },
    true
  );

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-skk-upsell-add]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const wrapper = button.closest('[data-skk-cart-upsell]');
    const quantityInput = wrapper ? wrapper.querySelector('[data-skk-upsell-qty]') : null;

    const variantId = Number(button.dataset.variantId);
    const maxQuantity = Number(button.dataset.max || quantityInput?.max || 1);

    let quantity = Number(quantityInput?.value || 1);

    if (!variantId) {
      showError(button, 'لم يتم العثور على المنتج.');
      return;
    }

    if (!quantity || quantity < 1) quantity = 1;
    if (quantity > maxQuantity) quantity = maxQuantity;

    hideError(button);

    button.disabled = true;
    button.classList.add('is-loading');
    button.dataset.originalText = button.textContent;
    button.textContent = 'جاري الإضافة...';

    try {
      const body = JSON.stringify({
        items: [
          {
            id: variantId,
            quantity,
          },
        ],
        sections: getSectionsToRender(),
        sections_url: window.location.pathname,
      });

      const response = await fetch(routes.cart_add_url, {
        ...fetchConfig('javascript'),
        body,
      });

      const parsedState = await response.json();

      if (!response.ok || parsedState.status) {
        throw new Error(parsedState.description || parsedState.message || 'Cart add error');
      }

      updateCartDrawer(parsedState);
      updateMainCartPage(parsedState);
      updateCartIcon(parsedState);
    } catch (error) {
      console.error(error);

      showError(button, 'لم نتمكن من إضافة المنتج. الرجاء المحاولة مرة أخرى.');

      button.disabled = false;
      button.classList.remove('is-loading');
      button.textContent = button.dataset.originalText || 'أضف الآن';
    }
  });

  document.addEventListener('DOMContentLoaded', initOfferGroups);
  initOfferGroups();
})();